import React from 'react';

import { Button } from '@yandex-360/orb-components/dist/components/Button';
import { Text } from '@yandex-360/orb-components/dist/components/Text';
import { ScopedTheme } from '@yandex-360/orb-components/dist/components/Theme';
import { useSelector } from 'react-redux';

import { ConferenceStatus } from '../../../pages/call/constants';
import { cancelCallAction } from '../../../pages/call/features/conference/slice';
import { getConferenceStatus, getJoinedAsGuest } from '../../../pages/call/selectors';
import { DisconnectReason } from '../../../pages/call/types';
import { getAutoJoin } from '../../features/config/selectors';
import { isMobileUa } from '../../features/uatraits';
import { STORE_URL_UNIVERSAL_SECONDARY } from '../../helpers/constants';
import { i18n } from '../../helpers/i18n';
import { useActions } from '../../hooks';
import styles from './styles.css';

export function NativeAppBanner() {
    const joinedAsGuest = useSelector(getJoinedAsGuest);
    const autoJoin = useSelector(getAutoJoin);
    const conferenceStatus = useSelector(getConferenceStatus);
    const { cancelCall } = useActions({ cancelCall: cancelCallAction });

    const isMobile = useSelector(isMobileUa);
    const shouldHideBanner =
        !isMobile ||
        !joinedAsGuest ||
        conferenceStatus === ConferenceStatus.JOINED ||
        (autoJoin && conferenceStatus === ConferenceStatus.JOINING);
    if (shouldHideBanner) {
        return null;
    }

    const handleBannerClick = () => {
        window.location.assign(STORE_URL_UNIVERSAL_SECONDARY);

        if (
            ![ConferenceStatus.DISCONNECTED, ConferenceStatus.READY_TO_JOIN, ConferenceStatus.JOINING].includes(
                conferenceStatus
            )
        ) {
            cancelCall({ skipFeedbackSaga: true, source: DisconnectReason.PAGE_LEAVE });
        }
    };

    return (
        <ScopedTheme theme="dark" force>
            <div className={styles.nativeAppBanner}>
                <Text className={styles.title} typography="body-md-bold">
                    {i18n('native-app-banner', 'telemost-has-chats')}
                </Text>
                <Button
                    elementType="a"
                    href={STORE_URL_UNIVERSAL_SECONDARY}
                    onClick={handleBannerClick}
                    size="sm"
                    view="contrast"
                >
                    {i18n('native-app-banner', 'download')}
                </Button>
            </div>
        </ScopedTheme>
    );
}
